export const WT_CONFIG = {

  // 获取租户静态资源及配置的源
  ASSETS_URL: location.origin,

  CRM_BASE_URL: '',
  // BO_BASE_URL: 'https://boapi.ddtt.pro:9022',
  BO_BASE_URL: 'https://boapitest.mt4.space:9017',
  // BO_BASE_URL: 'http://localhost:5998',
  FOX_BASE_URL: 'https://dhl2htzd9aydt.cloudfront.net',
  // FOX_BASE_URL: 'http://boapitest.mt4.space:9018',
  TERMS_CONDITIONS: '#',
  ABOUT_US: 'https://infinityplus.ai/member/wallet/convert',
  CRM_APP: '',
  LOGGING_BASE_URL: '',
  SECRET_KEY: '',

  BRAND_NAME: 'GDEX',
  MERCHANT_KEY: '12345',
  DOMAIN: '',
  appType: 'web',

  REGISTER_URI: '#',
  DEPOSIT_URI: 'https://infinityplus.ai/member/wallet/convert',
  WITHDRAWAL_URI: 'https://infinityplus.ai/member/wallet/convert',
  REFRESH_URI: '/api/v1/refresh',
  HISTORY_URI: '/api/v1/mt4/tradee?',
  HISTORY_ARCHIVE_URI: '/api/v1/mt4/archive-trade?',
  LOGIN_URI: '/api/v1/login?',
  LOGOUT_URI: '/api/v1/logout',
  FORGOT_PSWRD_URI: '/api/v1/forgot-password',
  APP_CONFIG_URI: '/api/v1/app-config',
  UPDATE_TOKEN: '/api/v1/update-token',
  USER_PROFILE: '/api/v1/profile',

  DEPOSIT_UPLOAD_URI: '/api/deposit/upload',
  DEPOSIT_CARD_URI: '/api/deposit/card',
  WITHDRAWAL_WT_URI: '/api/withdrawal',

  FOX_LOGIN_URI: '/v1/wt/login',
  FOX_LOGOUT_URI: '/api/logout',
  FOX_HISTORY_URI: '/v1/wt/trade',
  // FOX_HISTORY_ARCHIVE_URI: '/api/mt4/archive-trade?',
  FOX_REFRESH_URI: '/v1/wt/validate',

  FOX_VALIDATE_URI: '/v1/wt/validate',

  IMAGE_ROOT: '',
  GA_TRACKING_CODE: 'UA-123757204-4',

  WT_SERVER_APP: '',
  HIDE_DEPOSIT: false
};

export type WTConfig = typeof WT_CONFIG;

